// 商業登記受付帳 一括取得の最大検索件数のデフォルト値
const DEFAULT_COMMERCIAL_REGISTRATION_MAX_BULK_SEARCH_COUNT = 5;

/**
 * 商業登記受付帳 一括取得の最大検索件数を取得する
 * 環境変数 VITE_COMMERCIAL_REGISTRATION_MAX_BULK_SEARCH_COUNT が未設定の場合はデフォルト値の5を返す
 * @returns 商業登記受付帳 一括取得の最大検索件数
 */
export const getCommercialRegistrationMaxBulkSearchCount = (): number => {
  const envVal =
    process.env.VITE_COMMERCIAL_REGISTRATION_MAX_BULK_SEARCH_COUNT ?? "";
  const maxBulkSearchCount = Number(envVal);

  // 環境変数が正の整数で設定されてるならその値を返却 なければデフォルト値
  return Number.isInteger(maxBulkSearchCount) && maxBulkSearchCount > 0
    ? maxBulkSearchCount
    : DEFAULT_COMMERCIAL_REGISTRATION_MAX_BULK_SEARCH_COUNT;
};
